function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg43(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.94 80.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.24,3.6L0,7.13v5.52c0,3.04.65,6.77,1.43,8.3,1.08,2.08,1.59,8.98,2.05,27.7.73,29.67.93,31.43,3.54,31.43,2.82,0,6.9-8.89,8.51-18.5.37-2.2,1.32-6.62,2.12-9.82.8-3.2,1.68-9.46,1.96-13.92.28-4.45,1.18-9.69,1.99-11.64,1.78-4.27,2.92-13.96,2.04-17.45-.35-1.39-1.8-3.9-3.22-5.6-3.65-4.35-8.26-4.21-15.17.45",
    style: {
      fill: "#010101",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.82,6.08c2.08,3.05,2.3,4.26,1.78,9.44-.33,3.27-1.14,7.43-1.8,9.25-1.12,3.09-1.5,3.31-5.75,3.29-6.71-.02-9.04-.88-9.08-3.35-.02-1.17-.68-3.26-1.46-4.63s-1.45-4.59-1.46-7.15c-.03-4.31.24-4.82,3.71-6.98,7.99-4.96,10.62-4.93,14.07.13",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.91,39.02c-.76,10.96-4.47,28.08-7.49,34.53-1.29,2.76-2.38,4.8-2.42,4.52s-.29-8.38-.56-18-.67-20.33-.88-23.78l-.39-6.28,6.16.22,6.16.23-.59,8.56",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg43);
export default __webpack_public_path__ + "static/media/43.cd64f1eadee5b58c3f45309a4d0e32df.svg";
export { ForwardRef as ReactComponent };